import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CheckCircle2 } from 'lucide-react';
export function WhatYouGet() {
  const items = [{
    title: 'El eBook Maestro "Metabolismo 45+ Reset"',
    desc: 'El paso a paso completo del protocolo de 21 días.'
  }, {
    title: 'El Mapa de la Cocina Latina Inteligente',
    desc: 'Cómo sustituir arroz y arepas sin sacrificar el sabor.'
  }, {
    title: 'La Técnica de Control de Cortisol',
    desc: 'Ejercicios de 2 minutos para detener el almacenamiento de grasa abdominal.'
  }, {
    title: 'Guía de Compras en EE.UU.',
    desc: "Los mejores productos metabólicos en Costco, Walmart y Trader Joe's."
  }, {
    title: 'Lista de Verificación Diaria',
    desc: 'Para que nunca tengas que adivinar qué paso sigue.'
  }];
  return <section className="py-20 bg-[#FDF6F0]" data-id="element-190">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-191">
        <FadeIn data-id="element-192">
          <h2 className="text-3xl md:text-4xl font-serif text-[#1A5C4C] text-center mb-16" data-id="element-193">
            Todo lo que recibes hoy
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-194">
          <FadeIn data-id="element-195">
            <img src="https://cdn.magicpatterns.com/uploads/82eHBPEEvGavwdEKehMnt7/heylloyd-image-1773194508295_PROD_METABOLISMO.png" alt="Paquete completo Metabolismo 45+ Reset" className="w-full max-w-md mx-auto drop-shadow-2xl rounded-xl" data-id="element-196" />
          </FadeIn>

          <div className="space-y-6" data-id="element-197">
            {items.map((item, idx) => <FadeIn key={idx} delay={idx * 0.1} data-id="element-198">
                <div className="flex items-start space-x-4" data-id="element-199">
                  <CheckCircle2 className="w-6 h-6 text-[#1A5C4C] flex-shrink-0 mt-1" data-id="element-200" />
                  <div data-id="element-201">
                    <h3 className="text-lg font-bold text-[#2A2A2A]" data-id="element-202">
                      {item.title}
                    </h3>
                    <p className="text-[#2A2A2A] opacity-80" data-id="element-203">{item.desc}</p>
                  </div>
                </div>
              </FadeIn>)}
          </div>
        </div>
      </div>
    </section>;
}